$('#client').select2({
    minimumResultsForSearch: -1,
});
let page = 1
$('#client').on('select2:select', function (e) {
    let data = e.params.data.id;
    $.ajax({
        type: 'GET',
        url: `/api/v1/clients?country=${data}&page=1&per_page=8`,
        headers: {
            "x-localization": $('html').attr('lang'),
        }
    }).done(function (response) {
        page = 1
        response.data.button_hide ? $('.clients-pagination').fadeOut('fast') : $('.clients-pagination').fadeIn('fast')
        $('.clients-body-wrapper').html("");
        $('.clients-body-wrapper').append(response.data.clients)
    }).fail(function (error) {
    });
});

$('.clients-pagination-button').on('click', function (){
    $(this).addClass('load')
    let data = $('#client').val()
    page++
    $.ajax({
        type: 'GET',
        url: `/api/v1/clients?country=${data}&page=1&per_page=${8*page}`,
        headers: {
            "x-localization": $('html').attr('lang'),
        }
    }).done(function (response) {
        $('.clients-body-wrapper').html("");
        $('.clients-body-wrapper').append(response.data.clients)
        $('.clients-pagination-button').removeClass('load')
        response.data.button_hide ? $('.clients-pagination').fadeOut('fast') : $('.clients-pagination').fadeIn('fast')
    }).fail(function (error) {
        $('.clients-pagination-button').removeClass('load')
    });
})
